<template>
  <init-modal
    class="product-modal"
    :is-show="isShow"
    :is-bottom-position="screenWidth <= SCREENS.iPadMax"
    @close="closeModal"
  >
    <div class="product-modal__content">
      <app-product-slider :images="productImages" :need-reset-component="isShow" />
      <div class="product-modal__body">
        <div class="product-modal__body-product-desc">
          <h2 class="product-modal__body-title">
            {{ modalTitle }}
          </h2>
          <p class="product-modal__body-desc">
            {{ productBody || productDescription }}
          </p>
        </div>
        <div v-if="productVariantsListLength > 1" class="tapes-list">
          <app-radio-tape
            v-for="(radioData, key) in productVariantsList"
            :radio-group="key"
            :key="key"
            :radio-data="radioData"
          />
        </div>
        <div
          v-if="productBuyable"
          class="product-modal__accordions"
        >
          <app-accordion
            v-for="(groupModifier, index) in productVariants[activePriceIndex].groupModifiers"
            :key="index"
            :title="groupModifier.title"
          >
            <template #body>
              <template v-if="groupModifier.maxAmount === 1">
                <app-radio
                  v-for="radioModifier in groupModifier.modifiers"
                  :key="radioModifier.id"
                  :radio-data="{
                    groupName: groupModifier.title,
                    value: radioModifier.id,
                    label: radioModifier.productName,
                    isDefaultChecked: false,
                  }"
                  @change="selectRadioModifiersId($event, groupModifier.title)"
                />
              </template>
              <template v-if="groupModifier.maxAmount > 1">
                <app-checkbox
                  v-for="modifier in groupModifier.modifiers"
                  :key="modifier.id"
                  :label="`${modifier.productName} ${modifier.price} ₽`"
                  @change="selectCheckboxModifiersId(modifier.id)"
                />
              </template>
            </template>
          </app-accordion>
        </div>
        <template v-if="isUsingShopLogic">
          <app-button
            v-if="productBuyable && (amountProduct !== 0)"
            @click="addToBasket(productId)"
          >
            Добавить в корзину за {{ resultSum }} ₽
          </app-button>
          <app-button
            v-else
            is-disabled
          >
            Нет в наличии
          </app-button>
        </template>
      </div>
    </div>
  </init-modal>
</template>

<script>
import store from '@store'
import { mapMutations, mapState } from 'vuex'
import * as actions from '@store/types/actions-types'
import * as mutations from '@store/types/mutations-types'

import appRadio from '@ui/app-radio/appRadio.vue'
import appButton from '@ui/app-button/appButton.vue'
import appAccordion from '@components/appAccordion.vue'
import appCheckbox from '@ui/app-checkbox/appCheckbox.vue'
import appRadioTape from '@ui/app-radio-tape/appRadioTape.vue'
import initModal from '@ui/app-modals/init-modal/initModal.vue'
import AppProductSlider from '@ui/app-product-slider/appProductSlider.vue'

export default {
  name: 'ProductModal',
  components: {
    appRadio,
    initModal,
    appButton,
    appCheckbox,
    appAccordion,
    appRadioTape,
    AppProductSlider,
  },
  props: {
    isShow: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  emits: ['close'],
  data: () => ({
    currentSlideIndex: 0,
    image: [],
    checkboxModifiersIdList: [],
    radioModifiersIdList: {},
    resultModifiersIdList: [],
    selectedModifiersSum: 0,
  }),
  computed: {
    ...mapState({
      isUsingShopLogic: state => state.isUsingShopLogic,
      activePriceIndex: state => state.activePriceIndex,
      productId: state => state.product.id,
      productTitle: state => state.product.title,
      productBody: state => state.product.body,
      productDescription: state => state.product.description,
      productImages: state => state.product.images,
      productBuyable: state => state.product.isBuyable,
      productVariants: state => state.product.variants,
      productVariantsList: state => state.productVariantsList,
      modifiers: state => state.modifiers,
      amountProduct: state => state.amountProduct,
      screenWidth: state => state.screenWidth,
      SCREENS: state => state.screenSizeList,
    }),
    resultSum() {
      return this.productVariants[this.activePriceIndex].price + this.selectedModifiersSum
    },
    modalTitle() {
      const isSingleVariantOfRadioTape = Object.keys(this.productVariantsList).length === 1

      if (!isSingleVariantOfRadioTape) {
        return this.productTitle
      }
      if (isSingleVariantOfRadioTape) {
        const singleRadioList = Object.values(this.productVariantsList)[0]
        const singleRadioName = [...singleRadioList][0]

        return `${this.productTitle} (${singleRadioName})`
      }
    },
    productVariantsListLength() {
      return Object.keys(this.productVariantsList).length
    },
  },
  watch: {
    resultModifiersIdList() {
      const selectedModifiersList = this.productVariants[this.activePriceIndex].groupModifiers.flatMap(
        groupModifier => groupModifier.modifiers.filter(
          modifier => this.resultModifiersIdList.includes(modifier.id),
        ),
      )
      this.selectedModifiersSum = selectedModifiersList.reduce((acc, item) => acc + item.price, 0)
    },
  },
  methods: {
    ...mapMutations({
      setActiveToggle: mutations.SET_ACTIVE_TOGGLE,
      setAmount: mutations.SET_AMOUNT,
      changeToggleParameter: mutations.CHANGE_TOGGLE_PARAMETER,
    }),
    selectCheckboxModifiersId(id) {
      const index = this.checkboxModifiersIdList.indexOf(id)

      index > -1
        ? this.checkboxModifiersIdList.splice(index, 1)
        : this.checkboxModifiersIdList.push(id)

      this.changeResultModifiersArray()
    },
    selectRadioModifiersId(id, key) {
      this.radioModifiersIdList[`${key}Id`] = +id

      this.changeResultModifiersArray()
    },
    changeResultModifiersArray() {
      const radioListValues = Object.values(this.radioModifiersIdList)
      this.resultModifiersIdList = [...this.checkboxModifiersIdList, ...radioListValues]
    },
    closeModal() {
      this.$emit('close')
    },
    activateToggleProduct(keyOfVariant, indexOfVariantInList, productId, amount) {
      this.setActiveToggle([keyOfVariant, indexOfVariantInList])
      this.changeToggleParameter(productId)
      this.setAmount(amount)
      this.$store.commit(mutations.RESET_SELECTED_MODIFIERS)
    },
    addToBasket(productId) {
      store.dispatch(
        actions.ADD_TO_BASKET,
        { currentProductId: productId, currentModifierIds: this.resultModifiersIdList },
      )
    },
  },
}
</script>
